import { Globals } from '@bwoty-web/ui-kit';
import { hydrateRoot } from 'react-dom';
import PackagePlusMainOptionView from '../shared/views/packagePlus/PackagePlusMainOptionView';

const initialStateGeoPackagePlusMainOption =
  window.__INITIAL_STATE_GEO_PACKAGE_PLUS_MAIN_OPTION__;
delete window.__INITIAL_STATE_GEO_PACKAGE_PLUS_MAIN_OPTION__;
const geoPackagePlusMainOptionRoot = document.getElementById(
  'geo-package-plus-main_option-view',
);

if (geoPackagePlusMainOptionRoot) {
  const { mainOption, attributes, siteId, legacyMode, id } =
    initialStateGeoPackagePlusMainOption;
  hydrateRoot(
    geoPackagePlusMainOptionRoot,
    <Globals siteId={siteId} legacyMode={legacyMode}>
      <PackagePlusMainOptionView
        mainOption={mainOption}
        labels={attributes}
        id={id}
      />
    </Globals>,
  );
}
